import * as React from 'react';

function SvgSearch(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M21.694 19.992L17.16 15.46a8.376 8.376 0 001.678-5.04C18.838 5.777 15.061 2 10.42 2S2 5.777 2 10.42c0 4.642 3.777 8.418 8.42 8.418a8.376 8.376 0 005.039-1.678l4.534 4.534a1.205 1.205 0 001.7-1.701zM4.404 10.42a6.014 6.014 0 116.014 6.014 6.02 6.02 0 01-6.014-6.014z" })));
}

export default SvgSearch;
